export default "__VITE_ASSET__0BAt$hek__"